import { GIPHY_API_KEY } from '../constants/constants';

const limit = 12;

const GIF_LOADING = 'https://media0.giphy.com/media/{id}/200.gif';

interface SearchGifsParams {
  searchText: string;
  page?: number;
}

interface TrendingGifParams {
  page?: number;
}

async function searchGifs({ searchText, page = 0 }: SearchGifsParams): Promise<any> {
  try {
    const BASE_URL = 'https://api.giphy.com/v1/gifs/search';
    const url = `${BASE_URL}?api_key=${GIPHY_API_KEY}&q=${searchText}&limit=${limit}&offset=${limit * page}`;
    const resJson = await fetch(url);
    return await resJson.json();
  } catch (error) {
    console.log(error);
    throw error;
  }
}

async function trendingGif({ page = 0 }: TrendingGifParams): Promise<any> {
  try {
    const BASE_URL = 'https://api.giphy.com/v1/gifs/trending';
    const url = `${BASE_URL}?api_key=${GIPHY_API_KEY}&limit=${limit}&offset=${limit * page}`;
    const resJson = await fetch(url);
    return await resJson.json();
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export { searchGifs, trendingGif, limit, GIF_LOADING };
